import { Box, Button, useTheme, InputBase, IconButton } from '@mui/material';
import Header from 'components/Header';
import { colorTheme } from '../../theme';
import { useCallback, type ChangeEvent } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { debounce } from 'lodash';
import { strings } from 'i18n/Strings';

interface Props {
  title?: string;
  subtitle?: string;
  addButtonTitle?: string;
  addButtonTitle2?: string;
  editButtonTitle?: string;
  isShowExport?: boolean;
  searchEnabled?: boolean;
  onAddButtonClick?: () => void;
  onAddButtonClick2?: () => void;
  onUploadButtonClick?: (e: ChangeEvent<HTMLInputElement>) => void;
  onUpdateButtonClick?: () => void;
  onExportClick?: () => void;
  handleSearch?: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
  flag?: boolean;
  searchPlaceholder?: string;
  rightContent?: React.ReactNode;
}

const CustomTableHeader = ({
  title,
  subtitle,
  addButtonTitle,
  addButtonTitle2,
  editButtonTitle,
  isShowExport,
  onAddButtonClick,
  onAddButtonClick2,
  onUpdateButtonClick,
  onUploadButtonClick,
  onExportClick,
  flag,
  searchEnabled,
  handleSearch,
  searchPlaceholder,
  rightContent,
}: Props): JSX.Element => {
  const currentTheme = useTheme();
  const colors = colorTheme(currentTheme.palette.mode);

  const debounceSearchHandler = useCallback(
    handleSearch ? debounce(handleSearch, 1000) : null,
    [],
  );

  const searchPlace = window.location.href.includes('chat')
    ? strings.displayText.chatSearchLabel
    : strings.displayText.searchLabel;

  return (
    <Box display="flex" justifyContent="space-between" pb={1}>
      <Header title={title} subtitle={subtitle} />
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        {searchEnabled && (
          <Box
            display="flex"
            bgcolor={'#fff'}
            borderRadius={'3px'}
            marginRight={3}
          >
            <InputBase
              sx={{ ml: 2, flex: 1, width: '420px' }}
              placeholder={searchPlaceholder ?? searchPlace}
              onChange={debounceSearchHandler}
              onKeyDown={(e: { key: string; preventDefault: () => void }) => {
                if (e.key === '%') {
                  e.preventDefault();
                }
              }}
            />

            <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton>
          </Box>
        )}
        {rightContent}
        {editButtonTitle && (
          <Button
            variant="contained"
            sx={{
              height: 40,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              textTransform: 'none',
            }}
            onClick={onUpdateButtonClick}
          >
            {editButtonTitle}
          </Button>
        )}
        {addButtonTitle && !flag && (
          <Button
            variant="contained"
            sx={{
              height: 40,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              textTransform: 'none',
            }}
            onClick={onAddButtonClick}
          >
            {addButtonTitle}
          </Button>
        )}
        {addButtonTitle2 && !flag && (
          <Button
            variant="contained"
            sx={{
              height: 40,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              textTransform: 'none',
              margin: '0 10px 0',
            }}
            onClick={onAddButtonClick2}
          >
            {addButtonTitle2}
          </Button>
        )}
        {addButtonTitle && flag && (
          <Button
            variant="contained"
            sx={{
              height: 40,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              textTransform: 'none',
            }}
            component="label"
          >
            Upload File
            <input
              onChange={onUploadButtonClick}
              hidden
              accept=".csv,text/xml"
              type="file"
            />
          </Button>
        )}
        {isShowExport && (
          <Button
            variant="contained"
            sx={{
              height: 40,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              textTransform: 'none',
              margin: '0 10px 0',
            }}
            onClick={onExportClick}
          >
            Export
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CustomTableHeader;
